globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Social = appCustomerSpace.Modals.Social || {};

appCustomerSpace.Modals.Social.NewPost = (function (superClass) {

  utils.extend(NewPost, superClass);

  function NewPost() {
    return NewPost.__super__.constructor.apply(this, arguments);
  }

  $.extend(NewPost.prototype, {
    init: function () {
      var $modal = this.$html;
      $modal.on('change', 'input[name="social_post_form[creation_trigger_type]"]', function () {
        $modal.find('.form-group[data-trigger-type]').hide();

        var $submit = $modal.find('.submit');

        if ($(this).val() === 'automatic_from_user_services') {
          $modal.find('.form-group[data-trigger-type="automatic_from_user_services"]').show();
          $submit.html('<i class="fa fa-check position-left"></i> ' + $submit.data('searchLabel'));
        } else if ($(this).val() === 'automatic_from_library') {
          $modal.find('.form-group[data-trigger-type="automatic_from_library"]').show();
          $submit.html('<i class="fa fa-search position-left"></i> ' + $submit.data('searchLabel'));
        } else if ($(this).val() === 'manual_single') {
          $modal.find('.form-group[data-trigger-type="manual_single"]').show();
          $submit.html('<i class="fa fa-check position-left"></i> ' + $submit.data('createLabel'));
        }
      });

      return NewPost.__super__.init.apply(this, arguments);
    }
  });

  return NewPost;

})(appCustomerSpace.Modal);
